import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseCoreState, baseSharedActions, baseSharedSelectors } from '../../_store';

@Injectable({ providedIn: 'root' })
export class BasePspBranchesGuard {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(baseSharedActions.loadPspBranches({ payload: {} }));

    return this.store.select(baseSharedSelectors.getPspBranches).pipe(
      filter((result) => result.ok !== undefined),
      map((result) => !!result.ok)
    );
  }
}
